import { useNavigate, useParams } from 'react-router';
import { useEffect, useState } from 'react';
import axiosInstance from '../../../../utils/AxiosInstance';
import { useTrainingInfoById } from '../../../../hooks/Training';
import { BButton, BCard } from '../../../../components/ui/generic';
import { IconCheck, IconCircleCheckFilled, IconSquareCheckFilled } from '@tabler/icons-react';

const Finalisation = () => {
  const navigate = useNavigate();
  const { trainingId } = useParams();
  const { data } = useTrainingInfoById(trainingId);
  const [check, setCheck] = useState(false);
  useEffect(() => {
    axiosInstance.post(`internal_api/tunnel/finalisation/${trainingId}/check`).then((res) => {
      setCheck(res.data);
    });
  });
  const job = () => {
    if (check) return;
    const diabolocom = async () => {
      return axiosInstance.post('/internal_api/tunnel/finalisation/' + trainingId + '/diabolocom').catch((error) => {
        console.log(error);
      });
    };
    diabolocom();
  }

  useEffect(() => {
   job()
  }, []);
  return (
    <BCard maxSize={'md:max-w-2xl'} className={'mt-20'} outlineColor={'outline-primary-700'}>
      <BCard.Body>
        <div className={'flex items-center gap-2 px-8'}>
          <p className={'text-xl font-medium text-slate-700'}>Dossier en cours de validation</p>
        </div>
        <p className={'px-8 text-slate-700'}>
          Votre dossier a été transmis avec succès à notre chargée de relation entreprise.
        </p>
        <p className={'px-8 text-slate-700'}>
          Elle vous contactera dans les plus brefs délais afin de finaliser votre inscription et valider votre statut de stagiaire en formation.
        </p>
        <div className={'flex w-full justify-center gap-2.5'}>
          <div className={''}>
            <BButton label={"Retourner à l'acceuil"} size={'lg'} onClick={() => navigate('/')} />
          </div>
        </div>
      </BCard.Body>
    </BCard>
  );
};

export default Finalisation;
